import {Component, Input, OnInit} from '@angular/core';
import {ReplaySubject, Subject} from "rxjs";
import {loadingStatus, UiLoaderService} from "@app/feature/ui/ui-loader/ui-loader.service";

@Component({
  selector: 'ui-loader',
  templateUrl: './ui-loader.component.html',
  styleUrls: ['./ui-loader.component.scss']
})
export class UiLoaderComponent{
  constructor(private uiLoaderService: UiLoaderService) {
    this.name = null
    this.loadingStatus$ = this.uiLoaderService.loading$
    this.position = 'center'
  }

  @Input() public name?: string
  @Input() public position?: 'center'|'top'|'bottom'|'left'|'right'
  public loadingStatus$: ReplaySubject<loadingStatus>
}
